var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pay2-introduce-page"},[_c('img',{attrs:{"src":require("@/assets/pay2/introduce.jpeg")}})])
}]

export { render, staticRenderFns }